import { useEffect, useRef } from 'react';

export const useCloseTrigger = (open: boolean, close: () => void) => {
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    if (!open) return;
    const popup = ref.current;
    if (!popup) return;
    popup.focus();

    const keyboardHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        close();
      }
      e.stopPropagation();
    }

    const clickHandler = (e: MouseEvent) => {
      const { target } = e;
      if (target == null) return;
      const isClickedInside = popup.contains(target as Node);
      if (isClickedInside) return;
      close();
    }
    popup.addEventListener('keydown', keyboardHandler);
    document.addEventListener('click', clickHandler);
    return () => {
      popup.removeEventListener('keydown', keyboardHandler);
      document.removeEventListener('click', clickHandler);
    }
  }, [open, close]);

  return {
    ref,
  }
}